
export enum FactoryNodeScreenConfigCommandType {
    Boolean = "boolean",
    Number = "number",
    String = "string",
    Void = "void"
}